document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.querySelector('menu-drawer');
  const heroSection = document.getElementById('shopify-section-1764100724025c16ac');

  if (!drawer || !heroSection) return;

  const observer = new MutationObserver(function() {
    const isOpen = drawer.querySelector('details')?.hasAttribute('open') 
      || drawer.classList.contains('is-open')
      || document.documentElement.classList.contains('overflow-hidden');
    
    heroSection.style.zIndex = isOpen ? '-1' : '';
    heroSection.style.position = isOpen ? 'relative' : '';
  });

  observer.observe(drawer, { attributes: true, subtree: true, childList: true });
});
